/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesManifestResponse {
    getFixupPrototypeFunction() { return KubernetesManifestResponse.fixupPrototype; }

    static newInstance(model: Partial<KubernetesManifestResponse>): KubernetesManifestResponse {
        let obj = Object.assign(new KubernetesManifestResponse(), model);
        KubernetesManifestResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesManifestResponse>): KubernetesManifestResponse {
        if (!model) return null;
        return KubernetesManifestResponse.newInstance(<KubernetesManifestResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesManifestResponse) {
        if (!obj) return;

        models.KubernetesManifestResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesManifestResponse): boolean {
        Object.setPrototypeOf(obj, KubernetesManifestResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Yaml content
     */
    attachment_id: string;

}
